import { FC } from 'react'
import { StyledComponent } from '@emotion/styled'

import { LibStyledGrid } from './LibGrid.styles'

const LibGrid: FC<{ GridCells: JSX.Element[]; StyledGridOverride?: StyledComponent<{}> }> = ({
    GridCells,
    StyledGridOverride = LibStyledGrid,
}) => {
    {/* @ts-ignore */}
    return <StyledGridOverride>{GridCells}</StyledGridOverride>
}

export { LibGrid }
